
export const searchColumns = ["mobile","email","created_via_type"];


export const customerData = [
  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: false,
    isInternational: true,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: false,
    isInternational: false,
    isCorporateAccount: true,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: false,
    isInternational: true,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: false,
    isInternational: false,
    isCorporateAccount: true,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  { 
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },

  {
    fullName: "Ronaldo",
    mobile: "9876743210",
    email: "Ramkumar@gmail.com",
    city: "Delhi",
    isVip: true,
    isInternational: false,
    isCorporateAccount: false,
    created_via: "TMS"
  },
];

export const customerFilterColumns = [
  {
    name: "CUSTOMER NAME",
    value:'full_name',
    type:'text'
  },
  {
    name: "PHONE #",
    value:'mobile',
    type:'text'
  },
  {
    name: "EMAIL",
    value:'email',
    type:'text'
  },
  {
    name: "CITY",
    value:'city',
    type:'text'
  },
  {
    name: "CUSTOMER TYPE",
    value:'customer_type',
    type:'select',
    options:[
      {
        name:'VIP',
        value:'vip'
      },
      {
        name:'CORPORATE',
        value:'coorporate'
      }
    ]
  },
  // {
  //   name: "International",
  //   selector: (row) => row["international"],
  //   sortable: true,
  //   center: true,
  // },
  {
    name: "CREATED VIA",
    value:'created_via_type',
    type:'text'
  }
]

export const customerColumns = [
  {
    name: "CUSTOMER NAME",
    value:'cust_name',
    selector: (row) => row["customer_name"],
    sortable: true,
    center: true,
  },
  {
    name: "PHONE #",
    value:'cust_mobile',
    selector: (row) => row["phone_number"],
    sortable: true,
    center: true,
  },
  {
    name: "EMAIL",
    value:'email',
    selector: (row) => row["email"],
    sortable: true,
    center: true,
  },
  {
    name: "CITY",
    value:'service_city',
    selector: (row) => row["city"],
    sortable: true,
    center: true,
  },
  {
    name: "VIP",
    selector: (row) => row["vip"],
    center: true,
  },
  // {
  //   name: "International",
  //   selector: (row) => row["international"],
  //   sortable: true,
  //   center: true,
  // },
  {
    name: "CORPORATE",
    selector: (row) => row["corporate"],
    center: true,
  },
  {
    name: "CREATED VIA",
    selector: (row) => row["created_via"],
    sortable: true,
    center: true,
  },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width:"70px",
    // style: {
    //   backgroundColor: "white",
    //   position: "sticky",
    //   right: 0,
    //   zIndex: 0,
    //   justifyContent: "center !important"
    // },
  },
];
